import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import Dialog from "components/common/Dialog/Dialog";
import Button from "components/common/Button/Button";
import {
  ContainerButtonStyle,
  DeleteButtonsStyle,
} from "./DeleteSupplier.style";
import { ISuppliersDelete } from "./DeleteSupplier.types";
import { useSnackBar } from "hooks/useSnackBar";
import { useDeleteSupplierMutation } from "redux/api/suppliers/suppliers";

function DeleteSupplier({
  id,
  company_name,
  openDeleteDialog,
  setOpenDeleteDialog,
}: ISuppliersDelete) {
  const { t } = useTranslation();

  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();

  const [deleteCode, { data, error, isLoading }] =
    useDeleteSupplierMutation();

  if (error) {
    displayErrorApiSnackBar(error);
  }
  if (data) {
    displaySuccessSnackBar(t("supplier.successfully_deleted"));
  }

  const closeDeleteAlertDialog = useCallback(() => {
    setOpenDeleteDialog(false);
  }, [setOpenDeleteDialog]);

  const onSuccessDeleteAlert = (event: React.FormEvent) => {
    event.preventDefault();
    deleteCode(id);
    closeDeleteAlertDialog();
  };

  return (
    <Dialog
      open={openDeleteDialog}
      handleClose={closeDeleteAlertDialog}
      title={t("suppliers.delete")}
    >
      <form onSubmit={onSuccessDeleteAlert}>
        <p>
          {t("common.delete_message")}
          <span style={{ fontWeight: "bold", marginLeft: 5 }}>{company_name}</span>!
        </p>
        <DeleteButtonsStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              title={t("common.cancel_button")}
              onClick={closeDeleteAlertDialog}
            />
          </ContainerButtonStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              type="submit"
              loader={isLoading}
              title={t("common.confirm_button")}
            />
          </ContainerButtonStyle>
        </DeleteButtonsStyle>
      </form>
    </Dialog>
  );
}
export default DeleteSupplier;
